export enum CancellationReasons {
  FEATURES_MISSING = 'features_missing',
  NO_NEED = 'no_longer_need',
  SWITCHING = 'switched_software',
  CANT_DO = 'couldnt_do',
  TOO_EXPENSIVE = 'too_expensive',
  OTHER = 'other',
}
